/* KATRIO — interactions & motion. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var scrollers = []; // functions run on scroll (rAF-throttled)

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }

  /* ---------- Reveal on scroll (one shared observer) ---------- */
  var revealObs;
  function initReveal(root) {
    var els = $$('.gc-reveal:not(.gc-in)', root);
    if (!els.length) return;
    if (reduced || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gc-in'); });
      return;
    }
    revealObs = revealObs || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        (e.target._khR || [e.target]).forEach(function (n) { n.classList.add('gc-in'); });
        revealObs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      // clipped ("curtain") elements can't be observed directly, so watch their parent instead
      var t = el.getAttribute('data-gc-reveal') === 'curtain' && el.parentElement ? el.parentElement : el;
      if (t !== el) { t._khR = t._khR || []; t._khR.push(el); }
      revealObs.observe(t);
    });
  }

  /* ---------- Count-up stats ---------- */
  function initCounters(root) {
    var els = $$('[data-gc-count]:not([data-gc-done])', root);
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-gc-done', '1');
      var end = parseFloat(el.getAttribute('data-gc-count'));
      var suffix = el.getAttribute('data-gc-suffix') || '';
      var decimals = (el.getAttribute('data-gc-count').split('.')[1] || '').length;
      if (isNaN(end) || reduced) { el.textContent = (isNaN(end) ? el.getAttribute('data-gc-count') : end.toFixed(decimals)) + suffix; return; }
      var t0 = null, dur = 1600;
      (function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var v = end * (1 - Math.pow(1 - p, 4));
        el.textContent = v.toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { o.unobserve(e.target); run(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* ---------- Word-by-word highlight tied to scroll ---------- */
  function initWords(root) {
    $$('[data-gc-words]:not([data-gc-init])', root).forEach(function (el) {
      el.setAttribute('data-gc-init', '1');
      var text = el.textContent.trim().replace(/\s+/g, ' ');
      el.setAttribute('aria-label', text);
      el.classList.add('gc-words');
      el.innerHTML = text.split(' ').map(function (w) { return '<span class="gc-w" aria-hidden="true">' + w + '</span>'; }).join(' ');
      var words = $$('.gc-w', el);
      if (reduced) { words.forEach(function (w) { w.classList.add('is-lit'); }); return; }
      scrollers.push(function () {
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var p = clamp((vh * 0.86 - r.top) / (vh * 0.5 + r.height * 0.6), 0, 1);
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n); });
      });
    });
  }

  /* ---------- Parallax (image translate by scroll) ---------- */
  function initParallax(root) {
    if (reduced) return;
    $$('[data-gc-parallax]:not([data-gc-init])', root).forEach(function (el) {
      el.setAttribute('data-gc-init', '1');
      var amt = parseFloat(el.getAttribute('data-gc-parallax')) || 0.08;
      var host = el.parentElement;
      scrollers.push(function () {
        var r = host.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < -100 || r.top > vh + 100) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        el.style.setProperty('--gc-py', (c * -amt * 100).toFixed(2) + 'px');
      });
    });
  }

  /* ---------- Hero: gentle scroll parallax + zoom ---------- */
  function initHero(root) {
    var hero = $('.gc-hero:not([data-gc-init])', root);
    if (!hero || reduced) return;
    hero.setAttribute('data-gc-init', '1');
    var zoom = $('.gc-hero__zoom', hero);
    scrollers.push(function () {
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0) return;
      var p = clamp(-r.top / Math.max(r.height, 1), 0, 1);
      zoom.style.setProperty('--gc-py', (p * 60).toFixed(1) + 'px');
      zoom.style.setProperty('--gc-scale', (1 + p * 0.06).toFixed(3));
    });
  }

  /* ---------- Tilt cards + magnetic buttons (pointer devices only) ---------- */
  function initPointerFx(root) {
    if (reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('[data-gc-tilt]:not([data-gc-init])', root).forEach(function (el) {
      el.setAttribute('data-gc-init', '1');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transition = 'transform 0.15s ease-out';
        el.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg)';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform 0.8s cubic-bezier(0.22,1,0.36,1)';
        el.style.transform = '';
      });
    });
    $$('.gc-btn:not([data-gc-init])', root).forEach(function (el) {
      el.setAttribute('data-gc-init', '1');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.28;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Tabs (massage modes) ---------- */
  function initTabs(root) {
    $$('[data-gc-tabs]:not([data-gc-init])', root).forEach(function (wrap) {
      wrap.setAttribute('data-gc-init', '1');
      var tabs = $$('[role="tab"]', wrap), panels = $$('.gc-panel', wrap);
      function select(i) {
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        var sec = wrap.closest('.gc-modos');
        if (sec) {
          var speeds = ['4.6s', '3.4s', '6.4s'];
          sec.style.setProperty('--gc-pulse', speeds[i % 3]);
        }
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { select(i); }); });
      select(0);
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions(root) {
    $$('.gc-acc__q:not([data-gc-init])', root).forEach(function (btn) {
      btn.setAttribute('data-gc-init', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.gc-acc__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Sticky tech scene: highlight active feature + move focus ---------- */
  function initTech(root) {
    $$('[data-gc-tech]:not([data-gc-init])', root).forEach(function (sec) {
      sec.setAttribute('data-gc-init', '1');
      var feats = $$('.gc-feat', sec);
      if (!feats.length) return;
      function set(f) {
        feats.forEach(function (x) { x.classList.toggle('is-active', x === f); });
        sec.style.setProperty('--gc-fx', f.getAttribute('data-fx') + '%');
        sec.style.setProperty('--gc-fy', f.getAttribute('data-fy') + '%');
        sec.style.setProperty('--gc-fz', f.getAttribute('data-fz'));
      }
      set(feats[0]);
      if (!('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) set(e.target); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      feats.forEach(function (f) { o.observe(f); });
    });
  }

  /* ---------- Colour chips highlight one unit of the pair ---------- */
  function initSwatches(root) {
    $$('[data-gc-swatches]:not([data-gc-init])', root).forEach(function (wrap) {
      wrap.setAttribute('data-gc-init', '1');
      var img = $('.gc-colores__img', wrap.closest('.gc-section'));
      if (!img) return;
      $$('.gc-swatch', wrap).forEach(function (b) {
        function on() { img.setAttribute('data-active', b.getAttribute('data-side')); }
        function off() { img.removeAttribute('data-active'); }
        b.addEventListener('mouseenter', on); b.addEventListener('focus', on);
        b.addEventListener('mouseleave', off); b.addEventListener('blur', off);
        b.addEventListener('click', function () {
          var pressed = b.getAttribute('aria-pressed') === 'true';
          $$('.gc-swatch', wrap).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          if (!pressed) { b.setAttribute('aria-pressed', 'true'); on(); } else { off(); }
        });
      });
    });
  }

  /* ---------- Footer wordmark drift ---------- */
  function initFooterWord(root) {
    if (reduced) return;
    var w = $('.gc-footer__word:not([data-gc-init])', root);
    if (!w) return;
    w.setAttribute('data-gc-init', '1');
    scrollers.push(function () {
      var r = w.getBoundingClientRect(), vh = window.innerHeight;
      if (r.top > vh) return;
      var p = clamp((vh - r.top) / (vh * 0.5), 0, 1);
      w.style.setProperty('--gc-py', ((1 - p) * 40).toFixed(1) + 'px');
    });
  }

  /* ---------- Scroll progress bar ---------- */
  function initProgress() {
    if ($('.gc-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'gc-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    scrollers.push(function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? clamp(window.scrollY / h, 0, 1) : 0).toFixed(4) + ')';
    });
  }

  /* ---------- Product page: gallery, zoom, variants, qty, sticky bar ---------- */
  function initProduct(root) {
    $$('[data-gc-pdp]:not([data-gc-init])', root).forEach(function (pdp) {
      pdp.setAttribute('data-gc-init', '1');
      var main = $('.gc-gal__main', pdp), img = main && $('img', main), count = $('.gc-gal__count', pdp);
      var thumbs = $$('.gc-thumb', pdp);

      function show(i) {
        var t = thumbs[i]; if (!t || !img) return;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        img.classList.add('is-swap');
        setTimeout(function () {
          img.src = t.getAttribute('data-full'); img.alt = t.getAttribute('data-alt') || '';
          img.removeAttribute('srcset');
          img.onload = function () { img.classList.remove('is-swap'); };
          setTimeout(function () { img.classList.remove('is-swap'); }, 500);
        }, 180);
        if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

      if (main && !reduced && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        main.addEventListener('pointerenter', function () { main.classList.add('is-zoom'); });
        main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
        main.addEventListener('pointermove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--gc-zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          main.style.setProperty('--gc-zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }

      /* variants */
      var dataEl = $('[data-gc-variants]', pdp);
      var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var priceEl = $('[data-gc-price]', pdp), wasEl = $('[data-gc-was]', pdp), form = $('form[data-type="add-to-cart-form"]', pdp);
      var idInput = form && $('input[name="id"]', form), btn = form && $('.product-form__submit span', form), btnEl = form && $('.product-form__submit', form);
      var bar = $('.gc-sticky-bar', pdp), barPrice = bar && $('[data-gc-bar-price]', bar);
      var fieldsets = $$('.gc-opt', pdp);
      var bundle = $('[data-gc-bundle]', pdp);
      var saveWord = ($('[data-gc-bsave]', pdp) || { textContent: 'Save' }).textContent.split(' ')[0] || 'Save';
      if (bundle) {
        $$('input[type="radio"]', bundle).forEach(function (r) {
          r.addEventListener('change', function () {
            var qi = $('.gc-qty input', pdp); if (qi) qi.value = r.value;
          });
        });
      }
      var labels = { add: pdp.getAttribute('data-add') || 'Add to cart', sold: pdp.getAttribute('data-sold') || 'Sold out' };

      function money(c) {
        var fmt = pdp.getAttribute('data-money') || '${{amount}}';
        var n = fmt.indexOf('no_decimals') > -1 ? String(Math.round(c / 100)) : (c / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }
      function current() {
        var chosen = fieldsets.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
        return variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      }
      function apply() {
        var v = current(); if (!v) return;
        if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
        if (priceEl) priceEl.textContent = money(v.price);
        if (barPrice) barPrice.textContent = money(v.price);
        if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; } else { wasEl.hidden = true; } }
        var saveEl = $('[data-gc-save]', pdp);
        if (saveEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { saveEl.textContent = saveWord + ' ' + money(v.compare_at_price - v.price); saveEl.hidden = false; } else { saveEl.hidden = true; }
        }
        if (bundle) {
          var total = parseInt(bundle.getAttribute('data-total'), 10) || 0;
          var b1 = $('[data-gc-b1]', bundle), b2w = $('[data-gc-b2was]', bundle), bs = $('[data-gc-bsave]', bundle);
          if (b1) b1.textContent = money(v.price);
          if (b2w) b2w.textContent = money(v.price * 2);
          if (bs) bs.textContent = saveWord + ' ' + money(Math.max(v.price * 2 - total, 0));
        }
        if (btnEl) { btnEl.disabled = !v.available; if (btn) btn.textContent = v.available ? labels.add : labels.sold; }
        fieldsets.forEach(function (f) { var s = $('legend span', f), c = $('input:checked', f); if (s && c) s.textContent = c.value; });
        if (v.featured_image_idx > -1 && thumbs[v.featured_image_idx]) show(v.featured_image_idx);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
      }
      fieldsets.forEach(function (f) { f.addEventListener('change', apply); });

      /* quantity stepper */
      var q = $('.gc-qty input', pdp);
      $$('.gc-qty button', pdp).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(q.value, 10) || 1; n += b.getAttribute('data-d') === '+' ? 1 : -1; q.value = clamp(n, 1, 20);
        });
      });

      /* sticky add-to-cart bar (mobile) */
      if (bar && btnEl && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting); }, { threshold: 0 });
        o.observe(btnEl);
        $('.gc-btn', bar).addEventListener('click', function () { if (form && form.requestSubmit) form.requestSubmit(); });
      }
    });
  }

  /* ---------- Boot ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; for (var i = 0; i < scrollers.length; i++) scrollers[i](); });
  }
  function boot(root) {
    initReveal(root); initCounters(root); initWords(root); initParallax(root); initHero(root);
    initPointerFx(root); initTabs(root); initAccordions(root); initTech(root); initSwatches(root);
    initFooterWord(root); initProduct(root);
    onScroll();
  }
  function start() { initProgress(); boot(document); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
